<template lang="pug">
  el-container.container
    #tool-bar
      el-form(inline label-suffix=":")
        city-select(v-model="city" ev @change="changeCity")
        el-form-item(label="时间")
          el-date-picker(
            v-model="timeRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :clearable="false"
            range-separator="至"
          )
        el-form-item
          el-button(type="success" icon="el-icon-search" @click="getGrid")
    a-map.map(ref="amap" v-loading="loading" element-loading-text="拼命加载中, 时间可能会比较久...")
</template>

<script>
import citySelect from '@/components/citySelect';
import { getEvHeatMapGridsByCity } from '@/api/report';
import AMap from '@/components/AMap';
import moment from 'moment';

export default {
  name: 'Heatmap',
  components: {
    citySelect,
    AMap
  },
  data() {
    return {
      city: '',
      map: null,
      heatmap: null,
      loading: false,
      timeRange: [moment().subtract(6, 'hours').format('YYYY-MM-DD HH:mm:ss'), moment().format('YYYY-MM-DD HH:mm:ss')]
    };
  },
  computed: {},
  async mounted() {
    this.map = await this.$refs.amap.getMap();
    if (this.city) this.changeCity(this.city);
    this.map.plugin(['AMap.Heatmap'], () => {
      this.heatmap = new window.AMap.Heatmap(this.map, {
        radius: 20,
        opacity: [0, 0.8],
      });
    });
  },
  methods: {
    async getGrid() {
      if (!this.city) return this.$message.error('请选择城市!');
      const [beginTime, endTime] = this.timeRange;
      const bounds = this.map.getBounds();
      const zoomLevel = this.map.getZoom();
      const data = {
        beginTime,
        endTime,
        cityGuid: this.city,
        leftBottom: bounds.getSouthWest(),
        rightTop: bounds.getNorthEast(),
        zoomLevel
      };
      this.loading = true;
      const res = await getEvHeatMapGridsByCity(data);
      let heatmapData = res.data || [];
      heatmapData = heatmapData.sort((a, b) => a - b > 0).slice(1, -1);
      const max = Math.max(...heatmapData.map(item => item.count));
      this.heatmap.setDataSet({
        max,
        data: heatmapData
      });
      this.loading = false;
      return true;
    },
    async changeCity(city) {
      if (!this.map) {
        this.map = await this.$refs.amap.getMap();
      }
      this.map.setCity(city.cityName);
    },
  },
};
</script>

<style lang="scss" scoped>
.map {
  flex: 1;
}
.container{
  position: relative;
}
#tool-bar{
  position: absolute;
  opacity: .8;
  transition: opacity .3s ease;
  left: 80px;
  top: 12px;
  z-index: 1;
  background-color: #1C1E2F;
  padding: 8px 0 8px 8px;
  /deep/ .el-form-item--mini.el-form-item{
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/heatmap/evMap.vue?a353301a